import React from 'react';
import { motion } from 'framer-motion';
export function OrganizationsSection() {
  const organizaciones = [{
    name: 'CEDES',
    role: 'Cámara Ecuatoriana de Emprendimiento y Desarrollo Sostenible',
    color: 'border-brand-navy',
    logo: 'https://cdn.magicpatterns.com/uploads/rkTqzj3zzbtzJLRvC2mGq4/Logo_CEDES_Fondo_Trasparente_V2.0.png'
  }];
  return <section id="organizaciones" className="py-24 bg-brand-lightGray" data-id="element-380">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-381">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-382">
          <div className="max-w-2xl" data-id="element-383">
            <motion.h2 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="text-brand-royal font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-384">
              Nuestra Comunidad
            </motion.h2>
            <motion.h3 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-4xl md:text-5xl font-heading font-bold text-brand-navy" data-id="element-385">
              Organizaciones que son parte de la Red
            </motion.h3>
          </div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-386">
            <p className="text-gray-600 max-w-md md:text-right" data-id="element-387">
              Organizaciones sin fines de lucro que fortalecen su gestión,
              sostenibilidad e impacto a través de RedOrg.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-388">
          {organizaciones.map((org, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.4
        }} className={`bg-white rounded-2xl p-8 flex flex-col items-center justify-center text-center h-48 border-b-4 ${org.color} hover:shadow-lg transition-all duration-300 group cursor-default`} data-id="element-389">
              {org.logo ? <img src={org.logo} alt={`Logo ${org.name}`} className="h-14 w-auto object-contain mb-3 group-hover:scale-105 transition-transform" data-id="element-390" /> : <h4 className="text-2xl font-heading font-bold text-brand-navy mb-2 group-hover:scale-105 transition-transform" data-id="element-391">
                  {org.name}
                </h4>}
              <span className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-392">
                {org.role}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}